export default {
	"contactUs": {
		"title": "Open FCA account to gain access to leading regulation and money security",
		"title1": "Every serious trader deserves serious treatment.",
		"code": "Verification Code",
	},
	"dividend": {
		"title": "CFD Dividend",
		"title1": "CFD Dividend Reference:",
		"desc": "*Please note'ollection of CFD dividend will be reflected in the balance on your MT4 account as a deposit or withdrawal, annotated as “Dividend”.",
		"btn": "Start Trading"
	},
	"notice": "EBC Group has become aware that our name has been linked to an online Crypto offering by a company called 'EBankc'.<br/><br/>We would like to make it clear that EBC Group official websites are www.ebc.com and www.ebcfin.com which details its offerings and the products that it engages with.Crypto is not one of them.<br/><br/>We would also like to make it clear that EBC Financial Group (UK) Ltd only has one official website www.ebcfin.co.uk and gives a comprehensive record of the products we offer. Crypto is not one of them.<br/><br/>All EBC Group companies operate under the rules and regulations of the jurisdictions they operate in and will takes all steps necessary to stop any third party using its brand in unauthorised projects.",
	"contact": {
		"title": "your investment, start here",
		"pageTitle": "",
		"pageEnTitle": "INQUIRY",
		"name": "Name",
		"sexList": [{
			"label": "Mr.",
			"value": "sir"
		}, {
			"label": "Ms.",
			"value": "lady"
		}],
		"email": "Phone/Email",
		"btn": "Submit",
		"tips1": "Please enter your address!",
		"tips2": "Please enter your contact information!",
		"tips3": "Message succeeded!",
		"tips4": "Please enter the correct verification code!"
	},
	"column1": {
		"placeholder": "whole site search",
		"login": "Login",
		"langText": "EBC site region / language",
		"langList": [{
			"text": "简体",
			"value": "zh_CN"
		}, {
			"text": "繁体",
			"value": "zh_TW"
		}, {
			"text": "한국어",
			"value": "ko_KR"
		}, {
			"text": "日本語",
			"value": "ja_JP"
		}, {
			"text": "ئۇيغۇر تىلى",
			"value": "weiwuer"
		}]
	},
	"linkList": [{
		"title": "Account & Conditions",
		"list": [{
				"label": "Trading Accounts",
				"link": "/TradingAccount"
			},{
				"label": "Trading Products",
				"link": "/tradingproduct"
			},{
				"label": "Leverage & Margin",
				"link": "/leverage-margin"
			},
			{
				"label": "Deposit & Withdrawals",
				"link": "/funding"
			},
			{
				"label": "Dividend",
				"link": "/dividend"
			}
		]
	},{
		"title": "Trading Tools",
		"list": [{
				"label": "MT4 Download",
				"link": "/MT4"
			},{
				"label": "MT5 Download",
				"link": "/MT5"
			},{
				"label": "MT4 Trading Tools",
				"link": "/tools"
			}, {
				"label": "PAMM",
				"link": "/PAMM"
			}
		]
	},{
		"title": "EBC Institute",
		"list": [{
				"label": "Learning Center",
				"link": "/LearningCenter"
			}, {
				"label": "Data Center",
				"link": "/lab"
			}
		]
	}, {
		"title": "Activities",
		"list": [{
			"label": "Trading Contest",
			"link": "/win"
		},
		// {
		// 	"label": "Best Trading",
		// 	"link": "/no1"
		// },
		{
			"label": "Creator Incentive Programme",
			"link": "/cfa"
		},{
			"label": "Salary Scheme",
			"link": "/pay"
		}]
	}, {
		"title": "Partners",
		"list": [{
			"label": "Affiliate Programmes",
			"link": "/affiliate-programmes"
		},{
			"label": "Institutional Services",
			"link": "/service"
		},{
			"label": "Liquidity Solutions",
			"link": "/technology"
		},]
	}, {
		"title": "About EBC",
		"list": [{
			"label": "Why EBC",
			"link": "/about-us"
		},  {
			"label": "Legal Documents",
			"link": "/LegalDocumen"
		}, {
			"label": "Sustainability & Impact",
			"link": "/ESG"
		}, {
			"label": "FAQ",
			"link": "https://support.ebchelp.com/hc/en-001"
		},{
			"label": "Official Verification",
			"link": "/official-verification"
		}]
	}],
	"headlist": [{
		"text": "Home",
		"url": "/"
	}, {
		"text": "Trading",
		"menu": [{
			"text": "Trading Instruments",
			"url": "/tradingproduct"
		}, {
			"text": "Trading Accounts",
			"url": "/TradingAccount"
		}, {
			"text": "Trading Conditions",
			"menu": [{
				"text": "Deposit & Withdrawals",
				"url": "/funding"
			}, {
				"text": "Leverage & Margin",
				"url": "/leverage-margin"
			}]
		}, {
			"text": "Trading Platforms",
			"menu": [{
				"text": "MT4",
				"url": "/MT4"
			}, {
				"text": "MAM",
				"url": "/MAM"
			}]
		}, {
			"text": "Dividend",
			"url": "/dividend"
		}]
	}, {
		"text": "LAB&Tools",
		"menu": [{
			"text": "Learning Center",
			"url": "/LearningCenter"
		}, {
			"text": "Data Center",
			"url": "/lab"
		}]
	}, {
		"text": "Institutional",
		"menu": [{
			"text": "Liquidity Solutions",
			"url": "/technology"
		}, {
			"text": "Institutional Services",
			"url": "/service"
		}, {
			"text": "Partners",
			"url": "/partner"
		}]
	}, {
		"text": "Activities",
		"menu": [{
			"text": "Salary Scheme",
			"url": "/pay"
		}, {
			"text": "Challenge Trading Env",
			"url": "/No1"
		}]
	}, {
		"text": "About EBC",
		"menu": [{
			"text": "Why EBC",
			"url": "/about-us"
		}, {
			"text": "FAQ",
			"url": "https://support.ebchelp.com/hc/en-001"
		}]
	}, {
		"text": "Trading Competition",
		"url": "/win"
	}, {
		"text": "Copy Trading",
		"url": "https://ebcfinsns.co/"
	}, {
		"text": "Free Account",
		"url": "https://client.ebc-pro.com/signup?bid=5s71xp"
	}],
	"login": "Login",
	"zhuce": "Free Account",
	"gendan": "Social Trading",
	"pdfLang": "en",
	"bannerLang":"en",
	"language": "English",
	"className": "en-box",
	"text": "EBC Financial Group is a co-brand shared by a group of entities including:<br>EBC Financial Group (SVG) LLC is authorized by the St.Vincent and the Grenadines Financial Services Authority(SVGFSA),and the company registration number is 353 LLC 2020. with registered address at Euro House, Richmond Hill Road, Kingstown, VC0100, St. Vincent and the Grenadines.<br>Other Relevant Entities<br>EBC Financial Group (UK) Limited is authorised and regulated by the Financial Conduct Authority. Reference Number: 927552. Website:<a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcfin.co.uk\" rel=\"nofollow\">www.ebcfin.co.uk</a><br>EBC Financial Group (Australia) Pty Ltd (ACN: 619 073 237) is authorised and regulated by the Australian Securities and Investments Commission (Number: 500991). EBC Financial Group (Australia) Pty Ltd is a related entity of EBC Financial Group (SVG) LLC. The two entities are managed separately. The financial products and services offered on this website are NOT provided by the Australian entity and no recourse against the Australian entity is available.<br>EBC Financial Group (Cayman) Limited is licensed and regulated by the Cayman Islands Monetary Authority (Number: 2038223). Website: <a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcgroup.ky\" rel=\"nofollow\">www.ebcgroup.ky</a><br>Business Address: The Leadenhall Building, 122 Leadenhall Street, London, United Kingdom, EC3V 4AB. Email Address : cs@ebc.com. Telephone : +44 20 3376 9662<br>Disclaimer:EBC Financial Group explicitly does not participate in any cryptocurrency activities or offer Crypto Contracts for Difference (CFDs). Our financial services solely pertain to traditional instruments. Clients are advised that any references to crypto-related services using the EBC name are inaccurate and unauthorized. Any reference to past performance is not indicative of future performance. The information contained in this website is provided for reference only and does not constitute any investment advice.<br>Regional Restrictions:EBC does not offer any services to citizens and residents of certain jurisdictions including: Afghanistan, Belarus, Burma (Myanmar), Canada, Central African Republic, Congo, Cuba, Democratic Republic of the Congo, Eritrea, Haiti, Iran, Iraq, Lebanon, Libya, Malaysia, Mali, North Korea (Democratic People's Republic of Korea), Russia, Somalia, Sudan, South Sudan, Syria, Ukraine (including Crimea, Donetsk, and Luhansk Regions), the United States, Venezuela, and Yemen. For more information, please check out our FAQs.<br>Compliance Disclosure：The website can be accessed globally and is not specific to any entity. Your actual rights and obligations will be determined based on the entity and jurisdiction that you choose to be regulated.There may be local laws and regulations which prohibit or limit your rights to access, download, distribute, disseminate, share or otherwise use any or all of the documents and information published on this website.<br>Risk Warning: Trading Contracts for Difference (CFDs) are complex financial instruments and come with a high risk of losing money rapidly due to leverage. Trade on margin carries a high level of risk and may not be suitable for all investors. Before deciding to trade Forex and CFDs, you should carefully consider your trading objectives, level of experience and risk appetite. The possibility exists that you could sustain a loss of some or all of your initial trading capital. We recommend that you seek independent advice and ensure you fully understand the risks involved before making any investment decision. Please read the relevant risk disclosure statements carefully before trading.",
	"waptext": "EBC Financial Group is a co-brand shared by a group of entities including:<br>EBC Financial Group (SVG) LLC is authorized by the St.Vincent and the Grenadines Financial Services Authority(SVGFSA),and the company registration number is 353 LLC 2020. with registered address at Euro House, Richmond Hill Road, Kingstown, VC0100, St. Vincent and the Grenadines.<br>Other Relevant Entities<br>EBC Financial Group (UK) Limited is authorised and regulated by the Financial Conduct Authority. Reference Number: 927552. Website:<a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcfin.co.uk\" rel=\"nofollow\">www.ebcfin.co.uk</a><br>EBC Financial Group (Australia) Pty Ltd (ACN: 619 073 237) is authorised and regulated by the Australian Securities and Investments Commission (Number: 500991). EBC Financial Group (Australia) Pty Ltd is a related entity of EBC Financial Group (SVG) LLC. The two entities are managed separately. The financial products and services offered on this website are NOT provided by the Australian entity and no recourse against the Australian entity is available.<br>EBC Financial Group (Cayman) Limited is licensed and regulated by the Cayman Islands Monetary Authority (Number: 2038223). Website: <a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcgroup.ky\" rel=\"nofollow\">www.ebcgroup.ky</a><br>Business Address: The Leadenhall Building, 122 Leadenhall Street, London, United Kingdom, EC3V 4AB. Email Address : cs@ebc.com. Telephone : +44 20 3376 9662<br>Disclaimer:EBC Financial Group explicitly does not participate in any cryptocurrency activities or offer Crypto Contracts for Difference (CFDs). Our financial services solely pertain to traditional instruments. Clients are advised that any references to crypto-related services using the EBC name are inaccurate and unauthorized. Any reference to past performance is not indicative of future performance. The information contained in this website is provided for reference only and does not constitute any investment advice.<br>Regional Restrictions:EBC does not offer any services to citizens and residents of certain jurisdictions including: Afghanistan, Belarus, Burma (Myanmar), Canada, Central African Republic, Congo, Cuba, Democratic Republic of the Congo, Eritrea, Haiti, Iran, Iraq, Lebanon, Libya, Malaysia, Mali, North Korea (Democratic People's Republic of Korea), Russia, Somalia, Sudan, South Sudan, Syria, Ukraine (including Crimea, Donetsk, and Luhansk Regions), the United States, Venezuela, and Yemen. For more information, please check out our FAQs.<br>Compliance Disclosure：The website can be accessed globally and is not specific to any entity. Your actual rights and obligations will be determined based on the entity and jurisdiction that you choose to be regulated.There may be local laws and regulations which prohibit or limit your rights to access, download, distribute, disseminate, share or otherwise use any or all of the documents and information published on this website.<br>Risk Warning: Trading Contracts for Difference (CFDs) are complex financial instruments and come with a high risk of losing money rapidly due to leverage. Trade on margin carries a high level of risk and may not be suitable for all investors. Before deciding to trade Forex and CFDs, you should carefully consider your trading objectives, level of experience and risk appetite. The possibility exists that you could sustain a loss of some or all of your initial trading capital. We recommend that you seek independent advice and ensure you fully understand the risks involved before making any investment decision. Please read the relevant risk disclosure statements carefully before trading."
}

